{
  "rampsPresenter": {
    "title": "Plataformas – {{fboName}}",
    "stats": {
      "totalRamps": "Plataformas",
      "totalAircraft": "Total de aeronaves en plataformas"
    },
    "columns": {
      "rampName": "Plataforma",
      "currentAircraft": "Aeronave actual",
      "actions": "Acciones"
    },
    "tooltips": {
      "aircraftCount": "N.º de aeronaves en plataforma"
    },
    "emptyState": {
      "title": "Sin plataformas",
      "description": "Crea tu primera plataforma para comenzar a gestionar el estacionamiento y la programación de aeronaves."
    },
    "rampRow": {
      "buttons": {
        "currentRamp": "Plataforma actual",
        "rampSchedule": "Plataforma",
        "editTenants": "Editar inquilinos de amarre"
      }
    }
  }
}
